// Revisado: 2026-02-21 [UI/UX Overhaul - Premium Aesthetic - Hero Banner]
import React from 'react';
import { useTranslation } from 'react-i18next';

const SkillTableHeader = () => {
    const { t } = useTranslation();

    return (
        // HERO BANNER - UI DESIGN UPGRADE
        <div className="relative mb-6 overflow-hidden rounded-3xl bg-white dark:bg-gray-900 shadow-xl dark:shadow-2xl border border-gray-200 dark:border-gray-800 group transition-colors duration-300">
            {/* 1. Glow backgrounds (Reacting slightly on group-hover) */}
            <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/10 dark:bg-blue-600/20 rounded-full blur-3xl mix-blend-screen group-hover:bg-blue-500/20 dark:group-hover:bg-blue-500/30 transition-all duration-1000"></div>
            <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-teal-600/10 dark:bg-teal-600/20 rounded-full blur-3xl mix-blend-screen group-hover:bg-teal-500/20 dark:group-hover:bg-teal-500/30 transition-all duration-1000"></div>

            {/* 2. Grid texture overlay (Data-centric vibe) */}
            <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:32px_32px] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_100%)]"></div>

            <div className="relative z-10 px-8 py-10 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                <div className="flex-1 relative">

                    {/* 3. Decorative status tag (LED blinker) */}
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-500/10 border border-blue-200 dark:border-blue-500/20 text-blue-700 dark:text-blue-400 text-xs font-mono font-bold tracking-widest uppercase mb-4 shadow-sm dark:shadow-inner transition-colors duration-300">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                        </span>
                        {t('SkillTable.badge', 'System / Skills')}
                    </div>

                    {/* 4. Title Gradient */}
                    <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-br from-gray-900 via-gray-700 to-gray-500 dark:from-white dark:via-gray-100 dark:to-gray-500 tracking-tighter mb-4 drop-shadow-sm select-none transition-colors duration-300">
                        {t('SkillTable.database_title')}
                    </h1>

                    {/* 5. Subtitle with accent border */}
                    <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400 font-light max-w-2xl leading-relaxed border-l-2 border-teal-500/50 pl-4 transition-colors duration-300">
                        {t('SkillTable.subtitle', 'Complete database of Umamusume skills, costs, and effects.')}
                    </p>
                </div>

                {/* 6. Abstract graphical element */}
                <div className="hidden md:flex items-center justify-center relative w-32 h-32 shrink-0 select-none pointer-events-none">
                    <div className="absolute inset-0 border-[1px] border-blue-500/20 rounded-full animate-[spin_20s_linear_infinite]"></div>
                    <div className="absolute inset-4 border-[2px] border-dashed border-teal-500/20 rounded-full animate-[spin_15s_linear_infinite_reverse]"></div>
                    <div className="absolute inset-8 border-[1px] border-blue-300/20 rounded-full opacity-50"></div>
                    {/* Center Gem */}
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-teal-400 rounded-2xl shadow-[0_0_30px_rgba(59,130,246,0.4)] rotate-45 group-hover:rotate-180 transition-transform duration-1000 ease-in-out mix-blend-screen"></div>
                </div>
            </div>
        </div>
    );
};

export default SkillTableHeader;
